(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2341],{

/***/ 18205:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saas/partnerplatform",
      function () {
        return __webpack_require__(2926);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Accounts"
}); /*END_META*/ 


/***/ }),

/***/ 90986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Adding Custom Styles"
}); /*END_META*/ 


/***/ }),

/***/ 48317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "App customisation"
}); /*END_META*/ 


/***/ }),

/***/ 11260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Features available in tradly apps"
}); /*END_META*/ 


/***/ }),

/***/ 35773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Appstore Setup"
}); /*END_META*/ 


/***/ }),

/***/ 25192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Attributes"
}); /*END_META*/ 


/***/ }),

/***/ 38430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Auth Systems"
}); /*END_META*/ 


/***/ }),

/***/ 56400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Branch Metrics"
}); /*END_META*/ 


/***/ }),

/***/ 94485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{}); /*END_META*/ 


/***/ }),

/***/ 31910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Category"
}); /*END_META*/ 


/***/ }),

/***/ 87630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "In-built Chat"
}); /*END_META*/ 


/***/ }),

/***/ 63113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Launch Checklist"
}); /*END_META*/ 


/***/ }),

/***/ 26716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Deploying web apps in Cloudflare"
}); /*END_META*/ 


/***/ }),

/***/ 49128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Collections"
}); /*END_META*/ 


/***/ }),

/***/ 83544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Core Concepts"
}); /*END_META*/ 


/***/ }),

/***/ 67221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Commission"
}); /*END_META*/ 


/***/ }),

/***/ 68939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Composer"
}); /*END_META*/ 


/***/ }),

/***/ 7000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Coupon"
}); /*END_META*/ 


/***/ }),

/***/ 37177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Crowdfunding"
}); /*END_META*/ 


/***/ }),

/***/ 37607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Multi Currencies"
}); /*END_META*/ 


/***/ }),

/***/ 48576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Deeplinks"
}); /*END_META*/ 


/***/ }),

/***/ 38819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Delivery Methods"
}); /*END_META*/ 


/***/ }),

/***/ 80390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Checklist"
}); /*END_META*/ 


/***/ }),

/***/ 61798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Domain Setup"
}); /*END_META*/ 


/***/ }),

/***/ 56331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Creating Dynamic Pages"
}); /*END_META*/ 


/***/ }),

/***/ 77659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Editing Page Styles in Tradly"
}); /*END_META*/ 


/***/ }),

/***/ 60285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Editor Basic Overview"
}); /*END_META*/ 


/***/ }),

/***/ 75562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Solving Education"
}); /*END_META*/ 


/***/ }),

/***/ 14095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Email Setup"
}); /*END_META*/ 


/***/ }),

/***/ 37816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Discovery / Mobility Solutions"
}); /*END_META*/ 


/***/ }),

/***/ 21918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Facebook App"
}); /*END_META*/ 


/***/ }),

/***/ 9793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Firebase"
}); /*END_META*/ 


/***/ }),

/***/ 30531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Food Ecosystem"
}); /*END_META*/ 


/***/ }),

/***/ 96569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Google Analytics"
}); /*END_META*/ 


/***/ }),

/***/ 76536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Google Maps"
}); /*END_META*/ 


/***/ }),

/***/ 93959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Growth Checklist"
}); /*END_META*/ 


/***/ }),

/***/ 62951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Integrations FAQ"
}); /*END_META*/ 


/***/ }),

/***/ 89182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Inventory / Stocks"
}); /*END_META*/ 


/***/ }),

/***/ 77992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Signing up for Karix and Using as SMS gateway"
}); /*END_META*/ 


/***/ }),

/***/ 89406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Multi Language"
}); /*END_META*/ 


/***/ }),

/***/ 11866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Listings"
}); /*END_META*/ 


/***/ }),

/***/ 26787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Geo Location"
}); /*END_META*/ 


/***/ }),

/***/ 94691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "MangoPay"
}); /*END_META*/ 


/***/ }),

/***/ 79297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Media"
}); /*END_META*/ 


/***/ }),

/***/ 30293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Setting Up Negotiations"
}); /*END_META*/ 


/***/ }),

/***/ 53165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Netlify"
}); /*END_META*/ 


/***/ }),

/***/ 33775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Notifications"
}); /*END_META*/ 


/***/ }),

/***/ 84096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Online Payment Platform"
}); /*END_META*/ 


/***/ }),

/***/ 24521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Order & Checkout Methods"
}); /*END_META*/ 


/***/ }),

/***/ 11906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Solutions Ideas"
}); /*END_META*/ 


/***/ }),

/***/ 64811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": 'PayDunya"'
}); /*END_META*/ 


/***/ }),

/***/ 30688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Payment Methods"
}); /*END_META*/ 


/***/ }),

/***/ 41394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Playstore Setup"
}); /*END_META*/ 


/***/ }),

/***/ 19904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Different Products"
}); /*END_META*/ 


/***/ }),

/***/ 38345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Promotion"
}); /*END_META*/ 


/***/ }),

/***/ 61582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Q&A - Comments"
}); /*END_META*/ 


/***/ }),

/***/ 97405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Razorpay"
}); /*END_META*/ 


/***/ }),

/***/ 86580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Deploying web apps in Render"
}); /*END_META*/ 


/***/ }),

/***/ 79248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Analytics Features"
}); /*END_META*/ 


/***/ }),

/***/ 63676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Revenue Model"
}); /*END_META*/ 


/***/ }),

/***/ 84053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Review and Ratings"
}); /*END_META*/ 


/***/ }),

/***/ 93118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Booking Schedules"
}); /*END_META*/ 


/***/ }),

/***/ 5586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Customizing Screens",
    "shortTitle": "Screens"
}); /*END_META*/ 


/***/ }),

/***/ 78533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Search & Filters"
}); /*END_META*/ 


/***/ }),

/***/ 12137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "SEO"
}); /*END_META*/ 


/***/ }),

/***/ 28309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Checklist for Mobile Apps"
}); /*END_META*/ 


/***/ }),

/***/ 23344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Social Feed"
}); /*END_META*/ 


/***/ }),

/***/ 92647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stripe Connect"
}); /*END_META*/ 


/***/ }),

/***/ 16764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stripe Onboarding"
}); /*END_META*/ 


/***/ }),

/***/ 53402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stripe Payments"
}); /*END_META*/ 


/***/ }),

/***/ 6882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stuart Delivery"
}); /*END_META*/ 


/***/ }),

/***/ 75493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Submitting Template to the Tradly Marketplace"
}); /*END_META*/ 


/***/ }),

/***/ 69764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Subscription revenue model"
}); /*END_META*/ 


/***/ }),

/***/ 40409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{}); /*END_META*/ 


/***/ }),

/***/ 27763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Taxation"
}); /*END_META*/ 


/***/ }),

/***/ 25013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Template Creation"
}); /*END_META*/ 


/***/ }),

/***/ 48315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Test Apps"
}); /*END_META*/ 


/***/ }),

/***/ 78001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Custom Event Tracking"
}); /*END_META*/ 


/***/ }),

/***/ 22339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Translations"
}); /*END_META*/ 


/***/ }),

/***/ 65268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Signing up for Twilio and Using as SMS gateway"
}); /*END_META*/ 


/***/ }),

/***/ 12464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Users"
}); /*END_META*/ 


/***/ }),

/***/ 65949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Variants"
}); /*END_META*/ 


/***/ }),

/***/ 75005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Vercel Deployment"
}); /*END_META*/ 


/***/ }),

/***/ 99097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Account Wallet"
}); /*END_META*/ 


/***/ }),

/***/ 44717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Webhook"
}); /*END_META*/ 


/***/ }),

/***/ 67419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Things to setup in your website"
}); /*END_META*/ 


/***/ }),

/***/ 56012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Wishlist"
}); /*END_META*/ 


/***/ }),

/***/ 72957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Zapier"
}); /*END_META*/ 


/***/ }),

/***/ 2926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _partials_Cta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74756);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var Layout = (__webpack_require__(7346)/* .RootFileLayout */ .k);
var meta = {
    "title": "Build & Launch Your Partner Portal, Pages and Directory",
    "date": "2021-05-23"
};
var slug = "partnerplatform";
var tableOfContents = [
    {
        "title": "Building a defensible moat among the competition is hard",
        "slug": "building-a-defensible-moat-among-the-competition-is-hard",
        "children": []
    },
    {
        "title": "Purpose of Partner Ecosystem",
        "slug": "purpose-of-partner-ecosystem",
        "children": []
    },
    {
        "title": "Use Cases how you can use Tradly - Partner Portal",
        "slug": "use-cases-how-you-can-use-tradly-partner-portal",
        "children": [
            {
                "title": "1. App Store",
                "slug": "1-app-store",
                "children": []
            },
            {
                "title": "2. Service Directory",
                "slug": "2-service-directory",
                "children": []
            },
            {
                "title": "3. Experts Directory",
                "slug": "3-experts-directory",
                "children": []
            },
            {
                "title": "4. Reseller Directory",
                "slug": "4-reseller-directory",
                "children": []
            },
            {
                "title": "5. Developer Marketplace / Portal",
                "slug": "5-developer-marketplace-portal",
                "children": []
            },
            {
                "title": "6. Hardware Partner Networls",
                "slug": "6-hardware-partner-networls",
                "children": []
            }
        ]
    },
    {
        "title": "Example of Partner Portals and App Marketplaces",
        "slug": "example-of-partner-portals-and-app-marketplaces",
        "children": [
            {
                "title": "Shopify",
                "slug": "shopify",
                "children": []
            },
            {
                "title": "Github Marketplace",
                "slug": "github-marketplace",
                "children": []
            }
        ]
    }
];
var layoutProps = {
    Layout: Layout,
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = (__webpack_require__(87274)/* .CustomContentsLayout */ .NH);
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Looking to build your partner portal with directory and partner specific pages for your SaaS business?\nTradly provides a headless API and Open source templates to launch your partner directory and growing an ecosystem around it. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "building-a-defensible-moat-among-the-competition-is-hard",
        nextElement: {
            "type": "paragraph"
        }
    }, "Building a defensible moat among the competition is hard"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "With so much competition in every side of the business, it’s hard to build a sustainable price. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Price wars"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Features to features matrix comparison"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Brand Popularity & Distribution ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "It’s hard to compete in the ever growing SaaS wars, so how do we handle the sitautions? Build partner alliance, ecosystem, service providers network, etc around the brand can help your brand sustain. Until you take care of the partners, the partners will take care of your clients. Simple as that. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "It’s easy to launch a portal using Tradly but growing the partner ecosystem is a time take process, it evolves and gradually grows. If you have already a network of partners working on silo, then it must be easy to start and launch with a bang! "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/PartnerPortal.png",
        alt: "Shopify Appstore"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/Appstorepage.png",
        alt: "Shopify Appstore"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "FIND LIVE DEMO: ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://saaspartners.tradly.co/"
    }), "https://saaspartners.tradly.co/")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "purpose-of-partner-ecosystem",
        nextElement: {
            "type": "paragraph"
        }
    }, "Purpose of Partner Ecosystem"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "There must be a purpose behind why you are launching this and strategic goals. And this must be aligned with management, partnership team, channel managers and developer team. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "You could evolve your partner portal based on your business needs and the signals you get from this mini launches. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("table", {
        className: "text-lg"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("tbody", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("tr", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("td", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", null, " PHASE1 - Information ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("td", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", null, "PHASE2 - Community ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("td", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", null, "PHASE3 - Commerce "))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("tr", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("td", null, " Expert directory, Information based directory, Portal and Pages"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("td", null, " Ratings, Reviews, Partner Messaging"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("td", null, " Transactions, Subscription, Installing App ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("tr", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("td", null, " Zapier Expert Directory"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("td", null, " Wordpress.org ecosystem with review system "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("td", null, "Github and Atlassian Marketplace with Commerce")))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "use-cases-how-you-can-use-tradly-partner-portal",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "Use Cases how you can use Tradly - Partner Portal"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "1-app-store",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "1. App Store"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Partners who are building applications, software, add-ins, plugins, extensions on top of your product. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Example: Shopify Store, Hubspot, Intercom store, The big 5 appstores, etc. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Driven by: Product Managers, Product Marketers & Developer Relations")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "2-service-directory",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "2. Service Directory"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Deliver value added, outsourced IT services, integrations support, custom feature building services."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Example: SAP, Oracle Partners  ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "3-experts-directory",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": true
        }
    }, "3. Experts Directory"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Experts are pure collection of experts profile, their skill set and type of services they provide. ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Mailchimp expert directory ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://mailchimp.com/experts/"
    }), "https://mailchimp.com/experts/"), " ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Shopify Experts directory (Developers, designers and freelancers). ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://experts.shopify.com/"
    }), "https://experts.shopify.com/"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Zapier Experts Directory (", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://zapier.com/experts"
    }), "https://zapier.com/experts"), ")"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "4-reseller-directory",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "4. Reseller Directory"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Resell or distribute your software or hardware products.or build a channel through recruitment, development and enablement to reach customers at scale."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Also called as System integrator “SI”")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "5-developer-marketplace-portal",
        nextElement: {
            "type": "paragraph"
        }
    }, "5. Developer Marketplace / Portal"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Developer portals need more technical integrations. However this technical part where a users need to INSTALL app process happens mostly in the core product via webhook. So a directory can be served as merchandising solution"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Example: Github Developer Marketplace\n", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://github.com/marketplace/imgbot"
    }), "https://github.com/marketplace/imgbot")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "6-hardware-partner-networls",
        nextElement: {
            "type": "paragraph"
        }
    }, "6. Hardware Partner Networls"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Companies that you recommend or approve who has certain standard in their hardware product that support your business. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Manufacture devices like POS, sensorts, trackers, etc ")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_partials_Cta__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        mdxType: "Cta"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "example-of-partner-portals-and-app-marketplaces",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "Example of Partner Portals and App Marketplaces"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "shopify",
        nextElement: {
            "type": "jsx"
        }
    }, "Shopify"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/Snip20210522_165-1024x565.png",
        alt: "Shopify Appstore"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/Snip20210522_166-1024x661.png",
        alt: "Shopify Appstore"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/Snip20210522_167-1024x549.png",
        alt: "Shopify Appstore"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/Snip20210522_168-1024x495.png",
        alt: "Shopify Appstore"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "github-marketplace",
        nextElement: {
            "type": "jsx"
        }
    }, "Github Marketplace"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/githubmarketplace1.png",
        alt: "Intercom App Store"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/githubmarketplace2.png",
        alt: "Intercom App Store"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/githubmarketplace3.png",
        alt: "Intercom App Store"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/Snip20210522_169-1024x698.png",
        alt: "Intercom App Store"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/Snip20210522_171.png",
        alt: "Slack Appstore"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_partials_Cta__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        mdxType: "Cta"
    }));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 7346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ RootFileLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/layouts/SidebarLayout.js
var SidebarLayout = __webpack_require__(21744);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/img/tradly/Tradly MEta image.png
var Tradly_MEta_image = __webpack_require__(52066);
// EXTERNAL MODULE: ./src/components/Title.js
var Title = __webpack_require__(68224);
// EXTERNAL MODULE: ./src/navs/documentation.js + 2 modules
var documentation = __webpack_require__(54713);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(67129);
// EXTERNAL MODULE: ./src/components/Search.js + 2 modules
var Search = __webpack_require__(30112);
;// CONCATENATED MODULE: ./src/layouts/MagazineLayout.js








var SidebarContext = /*#__PURE__*/ (0,react.createContext)();
/**
 * Find the nearst scrollable ancestor (or self if scrollable)
 *
 * Code adapted and simplified from the smoothscroll polyfill
 *
 *
 * @param {Element} el
 */ function nearestScrollableContainer(el) {
    var isScrollable = /**
   * indicates if an element can be scrolled
   *
   * @param {Node} el
   */ function isScrollable(el) {
        var style = window.getComputedStyle(el);
        var overflowX = style["overflowX"];
        var overflowY = style["overflowY"];
        var canScrollY = el.clientHeight < el.scrollHeight;
        var canScrollX = el.clientWidth < el.scrollWidth;
        var isScrollableY = canScrollY && (overflowY === "auto" || overflowY === "scroll");
        var isScrollableX = canScrollX && (overflowX === "auto" || overflowX === "scroll");
        return isScrollableY || isScrollableX;
    };
    while(el !== document.body && isScrollable(el) === false){
        el = (el === null || el === void 0 ? void 0 : el.parentNode) || (el === null || el === void 0 ? void 0 : el.host);
    }
    return el;
}
function Wrapper(param) {
    var allowOverflow = param.allowOverflow, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: allowOverflow ? undefined : "overflow-hidden",
        children: children
    });
}
function MagazineLayout(param) {
    var children = param.children, navIsOpen = param.navIsOpen, setNavIsOpen = param.setNavIsOpen, nav = param.nav, sidebar = param.sidebar, fallbackHref = param.fallbackHref, tmp = param.layoutProps, ref = tmp === void 0 ? {} : tmp, _allowOverflow = ref.allowOverflow, allowOverflow = _allowOverflow === void 0 ? true : _allowOverflow;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarContext.Provider, {
        value: {
            nav: nav,
            navIsOpen: navIsOpen,
            setNavIsOpen: setNavIsOpen
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            allowOverflow: allowOverflow,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-10 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: children
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/layouts/RootFileLayout.js









function RootFileLayout(props) {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                suffix: router.pathname === "/" ? undefined : "Tradly",
                children: props.layoutProps.meta.metaTitle || props.layoutProps.meta.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }, "twitter:card"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://tradly.app".concat(Tradly_MEta_image/* default */.Z)
                    }, "twitter:image"),
                    props.layoutProps.meta.canonical && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: props.layoutProps.meta.canonical
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineLayout, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
}
RootFileLayout.nav = documentation/* documentationNav */.u;


/***/ }),

/***/ 54713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ documentationNav; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/utils/importAll.js
function importAll(r) {
    return r.keys().map(function(fileName) {
        return {
            fileName: fileName,
            module: r(fileName)
        };
    });
}

;// CONCATENATED MODULE: ./src/utils/createPageList.js




function createPageList(files, base) {
    return importAll(files).reduce(function(acc, cur) {
        var slug = cur.fileName.substr(2).replace(/\.mdx$/, "");
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, slug, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cur.module.default), {
            href: "/".concat(base, "/").concat(slug)
        })));
    }, {});
}

;// CONCATENATED MODULE: ./src/navs/documentation.js

var pages = createPageList(__webpack_require__(66708), "docs");
var documentationNav = {
    "Getting Started": [
        {
            title: "Setup",
            href: "/docs/setup",
            match: /^\/docs\/setup/
        },
        pages["commerce-definitions"],
        pages["checklist"],
        pages["appcustomisation"],
        pages["testingapp"],
        pages["products"],
        pages["translations"], 
    ],
    "Building Blocks": [
        pages["users"],
        pages["listings"],
        pages["attributes"],
        pages["variants"],
        pages["category"],
        pages["media"],
        pages["review-ratings"],
        pages["location"],
        pages["schedules"],
        pages["search"],
        pages["tags"],
        pages["wishlist"],
        pages["qa-comments"],
        pages["notifications"],
        pages["negotiations"],
        pages["inventory"], 
    ],
    Marketing: [
        pages["collection"],
        pages["promotion"],
        pages["coupon"],
        pages["seo"],
        pages["tracking"], 
    ],
    "Marketplace & Platform": [
        pages["accounts"],
        pages["wallet"],
        pages["chat"],
        pages["social"]
    ],
    "Business Blocks": [
        pages["delivery"],
        pages["paymentgateways"],
        pages["revenuemodel"],
        pages["commission"],
        pages["order"],
        pages["tax"], 
    ],
    "System Blocks": [
        pages["auth"],
        pages["language"],
        pages["currency"],
        pages["email"],
        pages["domain"], 
    ],
    "Editor Guides": [
        pages["template-create"],
        pages["editor-overview"],
        pages["editing-page-styles"],
        pages["dynamic-page"],
        pages["submit-template"], 
    ],
    Deployment: [
        pages["deployment"],
        pages["playstore"],
        pages["appstore"],
        pages["vercel"],
        pages["netlify"], 
    ],
    "Native Integrations": [
        pages["integrations-overview"],
        pages["webhook"],
        pages["zapier"],
        pages["firebase"],
        pages["stripe-payments"],
        pages["stripe-connect"],
        pages["stripe-onboarding"],
        pages["mangopay"],
        pages["onlinepaymentplatform"],
        pages["stuart"],
        pages["branch"],
        pages["google-maps"],
        pages["ga"],
        pages["facebookapp"], 
    ],
    "Solution - UNSDG Goals": [
        pages["crowdfunding"],
        pages["food"],
        pages["education"],
        pages["energy"],
        pages["othersolutions"], 
    ]
};


/***/ }),

/***/ 74756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




function Cta() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-6xl mx-auto px-4 sm:px-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pb-12 md:pb-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative bg-gray-100 rounded py-10 px-8 md:py-16 md:px-12 shadow-2xl overflow-hidden",
                    "data-aos": "zoom-y-out",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute right-0 bottom-0 pointer-events-none hidden lg:block",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                width: "428",
                                height: "328",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("radialGradient", {
                                            cx: "35.542%",
                                            cy: "34.553%",
                                            fx: "35.542%",
                                            fy: "34.553%",
                                            r: "96.031%",
                                            id: "ni-a",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                                    "stop-color": "#34CDB1",
                                                    "stop-opacity": "0.25"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                                    offset: "1",
                                                    "stop-color": "#34CDB1",
                                                    "stop-opacity": "0"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                        fill: "none",
                                        fillRule: "evenodd",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                                fill: "#34CDB1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".04",
                                                        cx: "185",
                                                        cy: "15.576",
                                                        rx: "16",
                                                        ry: "15.576"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".24",
                                                        cx: "100",
                                                        cy: "68.402",
                                                        rx: "24",
                                                        ry: "23.364"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "29",
                                                        cy: "251.231",
                                                        rx: "29",
                                                        ry: "28.231"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".64",
                                                        cx: "29",
                                                        cy: "251.231",
                                                        rx: "8",
                                                        ry: "7.788"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "342",
                                                        cy: "31.303",
                                                        rx: "8",
                                                        ry: "7.788"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".48",
                                                        cx: "62",
                                                        cy: "126.811",
                                                        rx: "2",
                                                        ry: "1.947"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "78",
                                                        cy: "7.072",
                                                        rx: "2",
                                                        ry: "1.947"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".64",
                                                        cx: "185",
                                                        cy: "15.576",
                                                        rx: "6",
                                                        ry: "5.841"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                fill: "url(#ni-a)",
                                                cx: "276",
                                                cy: "237",
                                                r: "200"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col lg:flex-row justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mb-6 lg:mr-16 lg:mb-0 text-center lg:text-left",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                            className: "h3 text-black mb-2",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400",
                                                    children: "Simple and FREE."
                                                }),
                                                " ",
                                                "Launch your project today!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "text-black text-lg opacity-75",
                                            children: [
                                                "- Launch Marketplaces, Online Storefronts, Booking Apps, Classifieds, Directories, Partner Portals, App Stores, etc.",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                " - Tradly pricing starts with ZERO. You pay only when you grow.",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                " - Free No-code Integrations, No-Code Editor"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "btn whitespace-nowrap bg-primary text-white px-20 ",
                                        href: "/signup",
                                        children: "SIGN UP NOW"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Cta);


/***/ }),

/***/ 66708:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./accounts.mdx": 69056,
	"./adding-custom-styles.mdx": 90986,
	"./appcustomisation.mdx": 48317,
	"./appfeatures.mdx": 11260,
	"./appstore.mdx": 35773,
	"./attributes.mdx": 25192,
	"./auth.mdx": 38430,
	"./branch.mdx": 56400,
	"./build-marketplace.mdx": 94485,
	"./category.mdx": 31910,
	"./chat.mdx": 87630,
	"./checklist.mdx": 63113,
	"./cloudflare.mdx": 26716,
	"./collection.mdx": 49128,
	"./commerce-definitions.mdx": 83544,
	"./commission.mdx": 67221,
	"./composer.mdx": 68939,
	"./coupon.mdx": 7000,
	"./crowdfunding.mdx": 37177,
	"./currency.mdx": 37607,
	"./deeplinks.mdx": 48576,
	"./delivery.mdx": 38819,
	"./deployment.mdx": 80390,
	"./domain.mdx": 61798,
	"./dynamic-page.mdx": 56331,
	"./editing-page-styles.mdx": 77659,
	"./editor-overview.mdx": 60285,
	"./education.mdx": 75562,
	"./email.mdx": 14095,
	"./energy.mdx": 37816,
	"./facebookapp.mdx": 21918,
	"./firebase.mdx": 9793,
	"./food.mdx": 30531,
	"./ga.mdx": 96569,
	"./google-maps.mdx": 76536,
	"./growth.mdx": 93959,
	"./integrations-overview.mdx": 62951,
	"./inventory.mdx": 89182,
	"./karix.mdx": 77992,
	"./language.mdx": 89406,
	"./listings.mdx": 11866,
	"./location.mdx": 26787,
	"./mangopay.mdx": 94691,
	"./media.mdx": 79297,
	"./negotiations.mdx": 30293,
	"./netlify.mdx": 53165,
	"./notifications.mdx": 33775,
	"./onlinepaymentplatform.mdx": 84096,
	"./order.mdx": 24521,
	"./othersolutions.mdx": 11906,
	"./paydunya.mdx": 64811,
	"./paymentgateways.mdx": 30688,
	"./playstore.mdx": 41394,
	"./products.mdx": 19904,
	"./promotion.mdx": 38345,
	"./qa-comments.mdx": 61582,
	"./razorpay.mdx": 97405,
	"./render.mdx": 86580,
	"./reports.mdx": 79248,
	"./revenuemodel.mdx": 63676,
	"./review-ratings.mdx": 84053,
	"./schedules.mdx": 93118,
	"./screens.mdx": 5586,
	"./search.mdx": 78533,
	"./seo.mdx": 12137,
	"./setup-app.mdx": 28309,
	"./social.mdx": 23344,
	"./stripe-connect.mdx": 92647,
	"./stripe-onboarding.mdx": 16764,
	"./stripe-payments.mdx": 53402,
	"./stuart.mdx": 6882,
	"./submit-template.mdx": 75493,
	"./subscription.mdx": 69764,
	"./tags.mdx": 40409,
	"./tax.mdx": 27763,
	"./template-create.mdx": 25013,
	"./testingapp.mdx": 48315,
	"./tracking.mdx": 78001,
	"./translations.mdx": 22339,
	"./twilio.mdx": 65268,
	"./users.mdx": 12464,
	"./variants.mdx": 65949,
	"./vercel.mdx": 75005,
	"./wallet.mdx": 99097,
	"./webhook.mdx": 44717,
	"./website.mdx": 67419,
	"./wishlist.mdx": 56012,
	"./zapier.mdx": 72957,
	"src/pages/docs/accounts.mdx": 69056,
	"src/pages/docs/adding-custom-styles.mdx": 90986,
	"src/pages/docs/appcustomisation.mdx": 48317,
	"src/pages/docs/appfeatures.mdx": 11260,
	"src/pages/docs/appstore.mdx": 35773,
	"src/pages/docs/attributes.mdx": 25192,
	"src/pages/docs/auth.mdx": 38430,
	"src/pages/docs/branch.mdx": 56400,
	"src/pages/docs/build-marketplace.mdx": 94485,
	"src/pages/docs/category.mdx": 31910,
	"src/pages/docs/chat.mdx": 87630,
	"src/pages/docs/checklist.mdx": 63113,
	"src/pages/docs/cloudflare.mdx": 26716,
	"src/pages/docs/collection.mdx": 49128,
	"src/pages/docs/commerce-definitions.mdx": 83544,
	"src/pages/docs/commission.mdx": 67221,
	"src/pages/docs/composer.mdx": 68939,
	"src/pages/docs/coupon.mdx": 7000,
	"src/pages/docs/crowdfunding.mdx": 37177,
	"src/pages/docs/currency.mdx": 37607,
	"src/pages/docs/deeplinks.mdx": 48576,
	"src/pages/docs/delivery.mdx": 38819,
	"src/pages/docs/deployment.mdx": 80390,
	"src/pages/docs/domain.mdx": 61798,
	"src/pages/docs/dynamic-page.mdx": 56331,
	"src/pages/docs/editing-page-styles.mdx": 77659,
	"src/pages/docs/editor-overview.mdx": 60285,
	"src/pages/docs/education.mdx": 75562,
	"src/pages/docs/email.mdx": 14095,
	"src/pages/docs/energy.mdx": 37816,
	"src/pages/docs/facebookapp.mdx": 21918,
	"src/pages/docs/firebase.mdx": 9793,
	"src/pages/docs/food.mdx": 30531,
	"src/pages/docs/ga.mdx": 96569,
	"src/pages/docs/google-maps.mdx": 76536,
	"src/pages/docs/growth.mdx": 93959,
	"src/pages/docs/integrations-overview.mdx": 62951,
	"src/pages/docs/inventory.mdx": 89182,
	"src/pages/docs/karix.mdx": 77992,
	"src/pages/docs/language.mdx": 89406,
	"src/pages/docs/listings.mdx": 11866,
	"src/pages/docs/location.mdx": 26787,
	"src/pages/docs/mangopay.mdx": 94691,
	"src/pages/docs/media.mdx": 79297,
	"src/pages/docs/negotiations.mdx": 30293,
	"src/pages/docs/netlify.mdx": 53165,
	"src/pages/docs/notifications.mdx": 33775,
	"src/pages/docs/onlinepaymentplatform.mdx": 84096,
	"src/pages/docs/order.mdx": 24521,
	"src/pages/docs/othersolutions.mdx": 11906,
	"src/pages/docs/paydunya.mdx": 64811,
	"src/pages/docs/paymentgateways.mdx": 30688,
	"src/pages/docs/playstore.mdx": 41394,
	"src/pages/docs/products.mdx": 19904,
	"src/pages/docs/promotion.mdx": 38345,
	"src/pages/docs/qa-comments.mdx": 61582,
	"src/pages/docs/razorpay.mdx": 97405,
	"src/pages/docs/render.mdx": 86580,
	"src/pages/docs/reports.mdx": 79248,
	"src/pages/docs/revenuemodel.mdx": 63676,
	"src/pages/docs/review-ratings.mdx": 84053,
	"src/pages/docs/schedules.mdx": 93118,
	"src/pages/docs/screens.mdx": 5586,
	"src/pages/docs/search.mdx": 78533,
	"src/pages/docs/seo.mdx": 12137,
	"src/pages/docs/setup-app.mdx": 28309,
	"src/pages/docs/social.mdx": 23344,
	"src/pages/docs/stripe-connect.mdx": 92647,
	"src/pages/docs/stripe-onboarding.mdx": 16764,
	"src/pages/docs/stripe-payments.mdx": 53402,
	"src/pages/docs/stuart.mdx": 6882,
	"src/pages/docs/submit-template.mdx": 75493,
	"src/pages/docs/subscription.mdx": 69764,
	"src/pages/docs/tags.mdx": 40409,
	"src/pages/docs/tax.mdx": 27763,
	"src/pages/docs/template-create.mdx": 25013,
	"src/pages/docs/testingapp.mdx": 48315,
	"src/pages/docs/tracking.mdx": 78001,
	"src/pages/docs/translations.mdx": 22339,
	"src/pages/docs/twilio.mdx": 65268,
	"src/pages/docs/users.mdx": 12464,
	"src/pages/docs/variants.mdx": 65949,
	"src/pages/docs/vercel.mdx": 75005,
	"src/pages/docs/wallet.mdx": 99097,
	"src/pages/docs/webhook.mdx": 44717,
	"src/pages/docs/website.mdx": 67419,
	"src/pages/docs/wishlist.mdx": 56012,
	"src/pages/docs/zapier.mdx": 72957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66708;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [73320,85220,96401,48777,26852,5679,49774,92888,40179], function() { return __webpack_exec__(18205); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);